import React, { useEffect } from 'react';
import { RecentContainer, RecentText } from './RecentComponents';
import SmallListItem from '../../Inputs/ListItems/SmallListItem';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
/**
 * this displays the last 4 stations listened to inside the sidebar
 * @example <Recent />
 * @returns {void}
 */
const Recent = () => {
  const location = useLocation();
  const { recentStations, favouriteStations, allStations } = useSelector(
    (state) => state.stations,
  );
  const [recent, setRecent] = React.useState([]);

  const createNewCopy = (arr) => {
    let map = [];
    arr.forEach((item, index) => {
      map[index] = Object.assign({}, item);
    });
    return map;
  };

  useEffect(() => {
    let map = createNewCopy(recentStations);
    let favs = createNewCopy(favouriteStations);
    let all = createNewCopy(allStations);

    favs.forEach((stationA) => {
      map.forEach((stationB) => {
        if (stationA.Id == stationB.Id) {
          stationB.Favorite = true;
        }
      });
    });

    all.forEach((stationA) => {
      map.forEach((stationB) => {
        if (stationA.Id == stationB.Id) {
          stationB.Favorite = true;
        }
      });
    });
    setRecent(
      map
        .filter((a) => typeof a != 'undefined' || a != false)
        .filter((b) => b.IsActive),
    );
  }, [recentStations, location]);

  /**
   * Renders the newly listened to stations inside a small list item.
   * @returns {void}
   */
  return (
    <RecentContainer>
      {recent.filter((station) => station != undefined && station.IsActive)
        .length ? (
        recent
          .filter(
            (station) => typeof station != 'undefined' && station.IsActive,
          )
          .map((station, index) => {
            return (
              <React.Fragment key={index}>
                <SmallListItem station={station} />
              </React.Fragment>
            );
          })
      ) : (
        <RecentText>No tienes emisoras escuchadas recientemente</RecentText>
      )}
    </RecentContainer>
  );
};

export default Recent;
